import { FORMAT, FORM_OPTIONS } from '@/CONSTS';
import { isMoment } from 'moment';

/**
 * フォームの入力値から画面表示用の文字列を作成する
 * @param String name - フォームデータ上のname属性値
 * @param String value - フォームデータ上のvalue属性値
 * @return String - 画面上で表示する値
 */
export default (name, value) => {
  if (!name || !value) {
    return '';
  }

  // radio・selectなどの選択式のもの
  if (
    name.includes('gender') ||
    name.includes('blood') ||
    name.includes('from_pref') ||
    name.includes('birthorder') ||
    name.includes('love_status') ||
    name.includes('connection_period') ||
    name.includes('connection_count') ||
    name.includes('lover_search_period') ||
    name.includes('romance_history') ||
    name.includes('neko_theme')
  ) {
    let text = value;
    let optionKey = name.replace('target_', '');
    if (FORM_OPTIONS.hasOwnProperty(optionKey)) {
      let selected = FORM_OPTIONS[optionKey].find(option => option.value === String(value));
      if (selected) {
        text = selected.text;
      }
    }
    return text;
  }

  // 生年月日 (YYYYMMDD形式を想定)
  if (name.includes('birthday')) {
    let formattedDate = moment(value).format(FORMAT.DATE);
    return formattedDate !== 'Invalid date' ? formattedDate : substr(value, 0, 8);
  }

  // 出生時間 (HHmm形式を想定)
  if (name.includes('birthtime')) {
    const parseBirthtimeValueToStr = (value = '') => {
      let timeArray = value ? value.match(/\d{2}/g) : null;
      let time = timeArray ? timeArray.join(':') : '99:99';
      let formattedTime = moment(`2000-01-01 ${time}`).format(FORMAT.TIME);
      return formattedTime !== 'Invalid date' ? formattedTime : '不明';
    };
    if ('object' === typeof value) {
      // 申込みフォームなど値+不明フラグのObjectで渡される場合
      if (+value.unknown) {
        return '不明';
      } else {
        return parseBirthtimeValueToStr(value.value);
      }
    } else {
      return parseBirthtimeValueToStr(value);
    }
  }

  if (name.includes('password')) {
    const passwordMaskChar = '*';
    return passwordMaskChar.repeat(value.length);
  }

  if (name.includes('order_detail') || name.includes('entry_detail')) {
    // 改行コードをbrタグにする
    return value.replace(/\n/g, '<br>');
  }

  // いずれにも該当しない場合そのまま値を返す
  return value;
};



// WEBPACK FOOTER //
// ./resources/assets/js/utils/paramToString.js